import { render } from "./card-distribute-dialog.vue?vue&type=template&id=2c053f4b&scoped=true"
import script from "./card-distribute-dialog.vue?vue&type=script&lang=js"
export * from "./card-distribute-dialog.vue?vue&type=script&lang=js"

import "./card-distribute-dialog.vue?vue&type=style&index=0&id=2c053f4b&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c053f4b"]])

export default __exports__